export const FEATURE_TAGS_STORAGE_KEY = 'gfknewron-feature-toggle';
export const FEATURE_TAGS_SEPARATOR = ',';

export const BETA_FLAG_STORAGE_KEY = 'gfknewron_feature_flag';
export const BETA_FLAG = 'beta';

const makeCamelCase = (str: string) => {
  return str.replace(/[-_]([a-z])/g, g => g[1].toUpperCase());
};

export const readFeatureTags = () => {
  const featureTagsString = localStorage.getItem(FEATURE_TAGS_STORAGE_KEY);
  const featureTags = featureTagsString ? featureTagsString.split(FEATURE_TAGS_SEPARATOR).map(tag => tag.trim()) : [];
  return featureTags;
};

export const hasFeatureTag = (flag: string) => {
  const featureTags = readFeatureTags();
  return featureTags.includes(flag);
};

export const getFeatureTags = () => {
  const featureTags = readFeatureTags();
  return featureTags.reduce((tags, tag) => {
    tags[makeCamelCase(tag)] = true;
    return tags;
  }, {});
};

/* to check beta feature flag */
export const hasBetaFeatureFlag = () => {
  const featureFlagString = localStorage.getItem(BETA_FLAG_STORAGE_KEY);
  return featureFlagString ? featureFlagString.includes(BETA_FLAG) : false;
};
